import { BaseTiledLayer } from "@/lib/map-layers/abstract/base-tiled-layer";

import { WmsTileImageLoader } from "./wms-tile-image-loader";

export default abstract class BaseWmsLayer extends BaseTiledLayer {
  constructor(dashboardId: string, mapLayerId: string) {
    super({
      tileImageLoader: new WmsTileImageLoader(dashboardId, mapLayerId),
    });
  }
}
